import { environment } from "../environments/environment";

export const appConfig = {
  // Login/Logout Urls
  logIn: environment.basePath + "v2/login",
  logOut: environment.basePath + "v2",

  // Preset Urls
  getPresetData:
    environment.basePath +
    "trueretailadmin/v2/table-columns?presetType=:presetType",
  addPresetData: environment.basePath + "trueretailadmin/v2/table-columns",
  updatePresetData: environment.basePath + "trueretailadmin/v2/table-columns",
  deletePresetData:
    environment.basePath + "trueretailadmin/v2/table-columns/:presetId",
  updateSelectedPreset:
    environment.basePath + "trueretailadmin/v2/selected-table-columns",

  // Report Urls
  getReportData:
    environment.basePath +
    "trueretailadmin/v2/list-report-pdf?reportType=:reportType&startDate=:startDate&lastDate=:lastDate&regionLocationId=:regionLocationId",
  getPdf:
    environment.basePath +
    "trueretailadmin/v2/download-file?fileName=:fileName&regionLocationId=:regionLocationId&fileType=:fileType",
  getListReportData:
    environment.basePath +
    "trueretailadmin/v2/location/list-report-pdf?startDate=:startDate&lastDate=:lastDate&regionLocationId=:regionLocationId",
  getExportedReport:
    environment.basePath +
    "trueretailadmin/v2/download/report?fileName=:fileName&regionLocationId=:regionLocationId&fileType=:fileType",

  // User Urls
  getUser: environment.basePath + "trueretailadmin/v2/users/:userId",
  switchUser: environment.basePath + "v2/switch/user/:userId",
  switchBack: environment.basePath + "v2/switch_back",
  switchUserAcrossCompany:
    environment.basePath + "v2/switch/user/:userId/across",
  saveUser: environment.basePath + "trueretailadmin/v2/users",
  getUsers: environment.basePath + "v2/users",
  deleteUser: environment.basePath + "trueretailadmin/v2/users/userId",
  updateUser: environment.basePath + "trueretailadmin/v2/users/:userId",
  updateUserAcrossCompany:
    environment.basePath + "trueretailadmin/v2/company/user/:userId",
  getUserProfile: environment.basePath + "v2/user-profile",
  updateUserProfile: environment.basePath + "trueretailadmin/v2/user-profile",
  updateUserImage:
    environment.basePath + "trueretailadmin/v2/file/user-profile",
  sendInvite:
    environment.basePath +
    "trueretailadmin/v2/users/invite-user?userId=:userId",
  createPassword:
    environment.basePath + "trueretailadmin/v2/users/set-password",
  forgetPassword:
    environment.basePath + "trueretailadmin/v2/users/forget-password",
  setforgetPassword:
    environment.basePath + "trueretailadmin/v2/users/forget/set-password",
  // Item Movement Urls
  getLocationsItems:
    environment.basePath +
    "dashboard/v1/location_sales?startDate=:startDate&lastDate=:lastDate&locationIds=:locationId",

  // Location Urls
  getLocationNew: environment.basePath + "trueretailadmin/v2/regionhierarchy",
  saveLocation: environment.basePath + "trueretailadmin/v2/locations",
  updateLocation:
    environment.basePath + "trueretailadmin/v2/locations/:locationId",
  storeSubscription:
    environment.basePath + "trueretailadmin/v2/store-subscription",

  // Company Urls
  getUserCompany: environment.basePath + "trueretailadmin/v2/users/company",
  getCompanyUsers: environment.basePath + "v2/users/company/:companyId",
  registerCompany: environment.basePath + "trueretailadmin/v2/company",
  updateCompany: environment.basePath + "trueretailadmin/v2/company/:companyId",
  updateCompanyLogo:
    environment.basePath +
    "trueretailadmin/v2/file/company-logo?companyId=:companyId",
  getCompanyList: environment.basePath + "trueretailadmin/v2/company",
  uploadCompanyLogo: environment.basePath + "trueretailadmin/v2/uploadImage",

  // Roles Urls
  getRoles: environment.basePath + "v2/roles",
  role: environment.basePath + "v2/roles/:roleId",

  // Authority Urls
  getAllAuthority: environment.basePath + "v2/authority_level",

  // Connectors Urls
  getConnectors: environment.basePath + "trueretailadmin/v2/connectors",
  getConnectorHealthCheck:
    environment.basePath + "trueretailconnector/v1/connector/health_check",
  updateConnector:
    environment.basePath + "trueretailadmin/v2/connectors/:connectorId",
  updateConnectorFlag:
    environment.basePath +
    "trueretailadmin/v1/connectorsflag/:connectorId?flagName=:flagName&flagValue=:flagValue",
  downloadTlogFilesUrl:
    environment.basePath +
    "trueretailadmin/v1/connectors/:connectorId/tlogfiles",
  getConnectorLogs:
    environment.basePath +
    "trueretailadmin/v2/connectors/:regionLocationId/logfile",
  getConnectorTLogs:
    environment.basePath +
    "trueretailadmin/v2/connectors/:regionLocationId/tlogfiles",
  downloadConnectorLogs:
    environment.basePath +
    "trueretailadmin/v2/download-file?fileName=:fileName&regionLocationId=:regionLocationId&fileType=:fileType",
  getConnectorSupportLogs:
    environment.basePath +
    "trueretailadmin/v2/connectors/:regionLocationId/supportfiles",
  uploadConnectorSupportLogs:
    environment.basePath +
    "trueretailadmin/v2/connectors/:regionLocationId/supportfiles",
  downloadConnectorSupportLogs:
    environment.basePath +
    "trueretailadmin/v2/download-file?fileName=:fileName&regionLocationId=:regionLocationId&fileType=:fileType",
  changeConnectorStatusUrl:
    environment.basePath +
    "trueretailadmin/v1/connectors/:connectorId/startstop/:status",
  resyncData:
    environment.basePath +
    "trueretailconnector/v1/connector/resync_data?locationIds=:locationIds&resyncStartDate=:resyncStartDate&resyncEndDate=:resyncEndDate&resyncSumJobType=:resyncSumJobType&resynctlogJobType=:resynctlogJobType",
  changeConnectorMasterDataResyncStatus:
    environment.basePath +
    "trueretailadmin/v2/connectors/:connectorId/startstop?:status",
  enableCgma:
    environment.basePath + "trueretailadmin/v2/enable/cgma/:connectorId",

  // Access groups
  accessGroups: environment.basePath + "v2/access_group",
  accessGroup: environment.basePath + "v2/access_group/:accessGroupId",

  // Permissions
  getPermissions: environment.basePath + "v2/permissions",
  getPermissionList: environment.basePath + "v2/permissions",

  // V2 Permissions
  getAllPermissions: environment.basePath + "v2/all/permissions",
  updatePermissionInfo: environment.basePath + "v2/permission/:permissionId",

  // Reset Password
  resetPassWord:
    environment.basePath + "trueretailadmin/v2/users/reset-password",
  resetUserPassWord:
    environment.basePath +
    "trueretailadmin/v2/users/reset-password?userId=:userId",
  resetConnectorCredential:
    environment.basePath +
    "trueretailadmin/v2/users/reset/connector/:connectorId/credential",

  // Hierarchy and Level Urls
  updateLevel: environment.basePath + "trueretailadmin/v2/organization/level",
  getRegions: environment.basePath + "trueretailadmin/v2/region",
  getUnassignedLocations:
    environment.basePath + "trueretailadmin/v2/unassigned_locations",
  getLocationHierarchy:
    environment.basePath + "trueretailadmin/v2/locationhierarchy",
  deleteRegionLocation:
    environment.basePath + "trueretailadmin/v2/region/:regLocId",
  deleteAllRegion: environment.basePath + "trueretailadmin/v2/all/region",

  // Transaction Urls
  getTransactionReceipt:
    environment.basePath +
    "trueretailadmin/v2/receipt?uniqueId=:uniqueId&regionLocationId=:regionLocationId&transactionDate=:transactionDate&recordNumber=:recordNumber&posCashierId=:posCashierId",
  getMultipleReceipt:
    environment.basePath +
    "trueretailadmin/v2/multi-receipt?uniqueIds=:uniqueIds&fromDate=:fromDate&toDate=:toDate&locationIds=:locationIds&recordNumbers=:recordNumbers",
  getTransactionWithUpc:
    environment.basePath +
    "dashboard/v1/transaction?startDate=:startDate&lastDate=:lastDate&locationIds=:locationId&upc=:upc",
  getTransactionEventsData: environment.basePath + "v2/transaction-events",
  updateTransactionStatus:
    environment.basePath +
    "trueretailadmin/v2/transaction?uniqueId=:uniqueId&businessDate=:businessDate&locationId=:locationId&recordNumber=:recordNumber&upcs=:upcs",

  // digital receipts
  resendReceipt:
    environment.basePath +
    "trueretailadmin/v2/digital/receipt?uniqueId=:uniqueId&regionLocationId=:regionLocationId&transactionDate=:transactionDate&recordNumber=:recordNumber&targetAddress=:targetAddress&posCashierId=:posCashierId",

  //Basket Analysis Urls
  submitBasketAnalysisQuery:
    environment.basePath +
    "analytics/spread_sheet?start_date=:start_date&end_date=:end_date&location=:location&item1=:item1&item2=:item2&tasktype=:tasktype&task_title=:task_title",
  retryPreviousBasketQueryUrl:
    environment.basePath + "analytics/spread_sheet_retry?taskid=:taskid",
  updatePreviousBasketQueryStatus:
    environment.basePath + "dashboard/v2/batch_analytics/update_status/taskid",

  // Tag Urls
  saveTag: environment.basePath + "trueretailadmin/v2/tag",
  updateTag: environment.basePath + "trueretailadmin/v2/tag",
  deleteTag: environment.basePath + "trueretailadmin/v2/tag/:tagId",
  getTagDataById: environment.basePath + "trueretailadmin/v2/tag/:tagId",

  //Sheets URL
  getAllDataPoint: environment.basePath + "trueretailadmin/v2/data_point",
  getSheetTableData:
    environment.basePath + "trueretailadmin/v2/location/values",
  shareSheetToUsersUrl: environment.basePath + "trueretailadmin/v2/share-sheet",
  saveLedger: environment.basePath + "trueretailadmin/v2/ledger-config",
  getledgerConfig:
    environment.basePath + "trueretailadmin/v2/ledger-config/:presetId/sheets",
  lockLedgerConfig:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/:presetId/sheets/:lock",
  getSubLedgerData:
    environment.basePath + "trueretailadmin/v2/ledger-config/sheet-data-points",
  saveLedgerPosData:
    environment.basePath + "trueretailadmin/v2/ledger-config/pos-assignment",
  updateLedgerData:
    environment.basePath + "trueretailadmin/v2/ledger-config/:presetId",
  getActivatedLedgerData:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/activated-ledger?isGlAccount=:isGlAccount",
  getSubLedgerPosData:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/sheet/:sheetId/pos-assignment",
  getSubLedgerDataPointsPosData:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/pos-assignment/:presetId/sheets",
  updateSubLedgerData:
    environment.basePath + "trueretailadmin/v2/ledger-config/sheet",
  createSubLedgerData:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/sheet?presetId=:presetId",
  deleteSubLedger:
    environment.basePath + "trueretailadmin/v2/ledger-config/:sheetId",
  saveLedgerCarryOver:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/sheet-carry-over?id=:id",
  saveLedgerWidgetData:
    environment.basePath + "trueretailadmin/v2/ledger-config/widget",
  saveGlAssignmentData:
    environment.basePath + "trueretailadmin/v2/ledger-config/gl-assignment",
  saveGlAssignmentColsData:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/column?presetId=:presetId",
  updateGlAssignmentColInfo:
    environment.basePath + "trueretailadmin/v2/ledger-config/column",
  deleteGlAssignmentColsData:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/column/:glConfigId",
  getMainLedgerDataInfo:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/gl-assignment?presetId=:presetId",
  saveSubLedgerOrder:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/:sequenceType/shuffle-sequence-order",
  updateAuthorityLevel:
    environment.basePath +
    "trueretailadmin/v2/ledger-config/ledger/authorityLevel",

  // Data Point Category URL
  getDataPointHierarchyUrl:
    environment.basePath + "trueretailadmin/v2/company/data_point_category",
  getDataPointUrl:
    environment.basePath + "trueretailadmin/v2/company/data_point",
  updateDpDescription:
    environment.basePath + "trueretailadmin/v2/data_point/:dpId",
  createNewCustomDp: environment.basePath + "trueretailadmin/v2/data_point",
  updateDpCategory:
    environment.basePath + "trueretailadmin/v2/company/data_point_category",
  unassignedDataPointUrl:
    environment.basePath + "trueretailadmin/v2/unassigned_data_points",
  assignDataPointUrl:
    environment.basePath + "trueretailadmin/v2/assign_data_points?dataPointIds",

  // Value Table URL
  updateDataPointInValueTable:
    environment.basePath +
    "trueretailadmin/v2/value_table?date=:date&locationId=:locationId&currentDateTime=:currentDateTime&isBookClosed=:isBookClosed&presetId=:presetId",
  uploadFinalizedLedgerGlExport:
    environment.basePath +
    "trueretailadmin/v2/uploadCSV?regionLocationId=:regionLocationId&date=:date",

  // InstaCart URL
  saveInstaCartList: environment.basePath + "trueretailadmin/v2/instaCart",
  disableLocationCards:
    environment.basePath + "trueretailadmin/v2/instaCart/:locationId",

  // Captcha Info
  captchchaSiteKey: "6Lf1r6EaAAAAAIOkOhSwIRDNqrdQS1H4iZYelYKQ",
  captchaSecretKey: "6Lf1r6EaAAAAAAcin5GPrEbxqTWHCPdDTk4Hu2YP",

  // Common GraphQL URL
  getCommonDataByGraphQl: environment.basePath + "graphql",
  saveCategory: environment.basePath + "trueretailadmin/v2/category",
  updateCategory:
    environment.basePath + "trueretailadmin/v2/category/:categoryId",

  //Customer Preference
  getCustomer: environment.basePath + "trueretailadmin/v2/customer-preference",
  deleteCustomer:
    environment.basePath + "trueretailadmin/v2/customer-preference/:id",
};
